import React from "react";

const IntroductionSkeleton: React.FC = () => {
  return (
    <div className="text-[18px] shadow-introBox font-outfit bg-white p-[32px] w-full md:w-[640px] rounded-[16px] animate-pulse">
      {/* Welcome Section Skeleton */}
      <div className="mb-6">
        {/* Welcome title */}
        <div className="h-6 bg-gray-200 rounded w-48 mb-6"></div>
        {/* Description */}
        <div className="space-y-2 mb-6">
          <div className="h-4 bg-gray-200 rounded w-full"></div>
          <div className="h-4 bg-gray-200 rounded w-3/4"></div>
        </div>
      </div>

      {/* Benefits List Section Skeleton */}
      <div className="mb-6">
        {/* "A few important things to know" title */}
        <div className="h-4 bg-gray-200 rounded w-56 mb-4"></div>

        {/* Benefits list items */}
        <div className="space-y-4 mb-6">
          {/* Benefit item 1 */}
          <div className="flex items-start">
            <div className="w-4 h-4 bg-gray-200 rounded-full mt-2 mx-2 flex-shrink-0"></div>
            <div className="flex-1 space-y-1">
              <div className="h-4 bg-gray-200 rounded w-full"></div>
              <div className="h-4 bg-gray-200 rounded w-5/6"></div>
            </div>
          </div>

          {/* Benefit item 2 */}
          <div className="flex items-start">
            <div className="w-4 h-4 bg-gray-200 rounded-full mt-2 mx-2 flex-shrink-0"></div>
            <div className="flex-1 space-y-1">
              <div className="h-4 bg-gray-200 rounded w-full"></div>
              <div className="h-4 bg-gray-200 rounded w-4/5"></div>
            </div>
          </div>

          {/* Benefit item 3 */}
          <div className="flex items-start">
            <div className="w-4 h-4 bg-gray-200 rounded-full mt-2 mx-2 flex-shrink-0"></div>
            <div className="flex-1 space-y-1">
              <div className="h-4 bg-gray-200 rounded w-full"></div>
              <div className="h-4 bg-gray-200 rounded w-3/4"></div>
            </div>
          </div>

          {/* Benefit item 4 */}
          <div className="flex items-start">
            <div className="w-4 h-4 bg-gray-200 rounded-full mt-2 mx-2 flex-shrink-0"></div>
            <div className="flex-1">
              <div className="h-4 bg-gray-200 rounded w-2/3"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IntroductionSkeleton;
